// Подключение функционала "Чертогов Фрилансера"
// import { isMobile } from "./functions.js";
// Подключение списка активных модулей
// import { flsModules } from "./modules.js";
//import Isotope from "isotope-layout";

//=====================< ISOTOPE >=====================//

window.addEventListener("load", () => {
	// // init Isotope
	// if (document.querySelector('.grid-assortment')) {
	// 	var iso = new Isotope(".grid-assortment", {
	// 		itemSelector: ".assortment-item",
	// 		layoutMode: "fitRows",
	// 	});
	// }

	// // store filter for each group
	// var filters = [];

	// // change is-checked class on buttons

	// var filtersElem = document.querySelector(".filter-assortment");
	// if (filtersElem) {
	// 	filtersElem.addEventListener("click", function (event) {
	// 		// only buttons
	// 		var target = event.target;
	// 		if (!target.hasAttribute("data-filter")) {
	// 			return;
	// 		}
	// 		target.classList.toggle("_checked");
	// 		var isChecked = target.classList.contains("_checked");
	// 		var filter = target.getAttribute("data-filter");
	// 		if (isChecked) {
	// 			addFilter(filter);
	// 		} else {
	// 			removeFilter(filter);
	// 		}
	// 		const filtersValue = document.querySelector(".filters-value");
	// 		if (filters.length > 0 && !target.classList.contains("filter-assortment__category-item")) {
	// 		} else if (filters.length > 0 && target.classList.contains("filter-assortment__category-item")) {
	// 			filtersValue.innerHTML = " (" + filters.length + ")";
	// 		} else {
	// 			filtersValue.innerHTML = "";
	// 		}
	// 		// filter isotope
	// 		// group filters together, inclusive
	// 		iso.arrange({ filter: filters.join(",") });
	// 	});
	// }

	// function addFilter(filter) {
	// 	if (filters.indexOf(filter) == -1) {
	// 		filters.push(filter);
	// 	}
	// }

	// function removeFilter(filter) {
	// 	var index = filters.indexOf(filter);
	// 	if (index != -1) {
	// 		filters.splice(index, 1);
	// 	}
	// }

	//=====================< VIEW-MODE >=====================//
	// const viewMode = document.querySelector("[data-view-mode]");
	// const assortmentContent = document.querySelector(".assortment__content");
	// const gridMode = document.querySelector("#grid-mode");
	// const cardMode = document.querySelector("#card-mode");
	// if (viewMode) {
	// 	viewMode.dataset.viewMode = "grid";
	// cardMode.classList.add("_active");
	// 	viewMode.addEventListener("click", function(changeViewMode) {
	// 	if (viewMode.dataset.viewMode == "grid") {
	// 	viewMode.dataset.viewMode = "card";
	// 	assortmentContent.classList.add("_card-view");
	// 	gridMode.classList.toggle("_active");
	// 	cardMode.classList.toggle("_active");
	// 	} else {
	// 	viewMode.dataset.viewMode = "grid";
	// 			assortmentContent.classList.remove("_card-view");
	// 	gridMode.classList.toggle("_active");
	// 			cardMode.classList.toggle("_active");
	// 	}
	// });
	// }

});